import React from "react"
import { Container } from "react-bootstrap"
import Banner from "component/Banner"
import { localize } from "services/base"

const BasePage = ({ children }) => {
      const t = (key) => localize(key)
      return (
            <div className="basepage">
                  <Container className="basepage__container p-2 pb-5">
                        <Banner />
                        <p className="fw-bold text-center mb-lg-5 fs-5">{t('title')}</p>
                        {children}
                  </Container>
            </div>
      )
}

export default BasePage